<template>
  <div class="d-flex justify-end">
    <v-btn color="error" @click="showDialog = true">
      {{ t("components.companies.block.button") }}
    </v-btn>

    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title class="mx-2">
          {{ t("components.companies.block.title") }}
        </v-card-title>
        <v-card-text>{{ t("components.companies.block.confirmMessage") }}</v-card-text>
        <v-card-actions class="ma-4">
          <v-btn-nd @click="showDialog = false">
            {{ t("form.cancel") }}
          </v-btn-nd>
          <v-spacer />
          <v-btn color="error" variant="elevated" :loading="isLoading" @click="blockCompany">
            {{ t("form.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useYetipayApi } from "@/composables/useYetipayApi";
import { useApplicationStore } from "@/store/application";

const { t } = useI18n();
const applicationStore = useApplicationStore();
const { api, currentMerchantId } = useYetipayApi();

const showDialog = ref(false);
const isLoading = ref(false);

const blockCompany = async () => {
  try {
    isLoading.value = true;
    await api.blockMerchant(currentMerchantId);

    applicationStore.notifyUser({
      message: t("components.companies.block.successMessage"),
      type: "success",
    });
    showDialog.value = false;
  } catch (error: unknown) {
    console.error(error);
    applicationStore.notifyUser({
      message: t("components.companies.block.errorMessage"),
      type: "error",
    });
  } finally {
    isLoading.value = false;
  }
};
</script>
